import React from 'react'
import PropTypes from 'prop-types'

const Alert = ({ width = '32', height = '32' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height}>
    <defs>
      <clipPath id='alert'>
        <path
          data-name='Rectangle 4088'
          transform='translate(22625 -17620)'
          fill='none'
          stroke='#707070'
          d='M0 0h32v32H0z'
        />
      </clipPath>
    </defs>
    <g data-name='Alert 1' transform='translate(-22625 17620)' clipPath='url(#alert)'>
      <g data-name='Group 8899' fill='#e07912'>
        <path
          data-name='Polygon 5'
          d='M22641-17617.881a1.977 1.977 0 0 0-1.743 1.019l-12.871 22.881a2 2 0 0 0 1.744 2.981h25.74a2 2 0 0 0 1.743-2.981l-12.87-22.88a1.977 1.977 0 0 0-1.743-1.02m0-1a2.971 2.971 0 0 1 2.615 1.529l12.87 22.881a3 3 0 0 1-2.615 4.471h-25.74a3 3 0 0 1-2.615-4.471l12.87-22.881a2.971 2.971 0 0 1 2.615-1.529Z'
        />
        <path
          data-name='Path 15289'
          d='m22641.869-17609.091-.128 9.409h-1.482l-.128-9.409Zm-.869 13.191a1.107 1.107 0 0 1-.812-.337 1.107 1.107 0 0 1-.339-.812 1.107 1.107 0 0 1 .339-.811 1.107 1.107 0 0 1 .812-.34 1.107 1.107 0 0 1 .812.339 1.107 1.107 0 0 1 .339.812 1.1 1.1 0 0 1-.157.575 1.2 1.2 0 0 1-.415.419 1.1 1.1 0 0 1-.579.155Z'
        />
      </g>
    </g>
  </svg>
)

Alert.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}

export default Alert
